export default "__VITE_ASSET__C9wL4EeC__"